
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.8 1.6V5c0 .33.27.6.6.6h3.4v8.2c0 .332-.267.6-.6.6H3.8a.599.599 0 01-.6-.6V2.2c0-.333.268-.6.6-.6h5zm1.378.175l2.447 2.45a.598.598 0 01.175.422V4.8H9.6V1.6h.153a.6.6 0 01.425.175zM8.8 7.4a.6.6 0 00-.6-.6h-2a.6.6 0 100 1.2h2a.6.6 0 00.6-.6zm1 1.4a.6.6 0 110 1.2H6.2a.6.6 0 110-1.2h3.6zm-1 2.6a.6.6 0 00-.6-.6h-2a.6.6 0 100 1.2h2a.6.6 0 00.6-.6z","fill":"#525F7F"}})])
          )
        }
      }
    